import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { chrRoutes } from './app-chr-routing';
import { classicRoutes } from './app-classic-routing';
import { delegateRoutes } from './app-delegate-routing';
import { managerRoutes } from './app-manager-routing';
import { AuthenticationGuardService } from './auth/guards/authentication-guard';
import { HrGuardService } from './auth/guards/hr-guard';
import { DefaultComponent } from './default/default.component';
import { StyleGuideSettingsComponent } from './shared/style-guides/style-guide-settings/style-guide-settings.component';
import { StyleGuideComponent } from './shared/style-guides/style-guide/style-guide.component';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'default',
    component: DefaultComponent,
  },
  {
    path: 'absence-management',
    loadChildren: () =>
      import('./modules/absence-management/absence.module').then((m) => m.AbsenceModule),
    canActivate: [AuthenticationGuardService, HrGuardService],
  },
  {
    path: '',
    loadChildren: () => import('./modules/authentication/authentication.module').then((m) => m.AuthenticationModule),
    data: {
      access: 'public',
    },
  },
  {
    path: 'competences',
    loadChildren: () =>
      import('./modules/competences/competence.module').then(
        (m) => m.CompetenceModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: 'conversations',
    loadChildren: () =>
      import('./modules/conversations/conversations.module').then(
        (m) => m.ConversationsModule
      ),
    canActivate: [AuthenticationGuardService]
  },
  {
    path: 'development-objectives',
    loadChildren: () =>
      import('./modules/development-objectives/development-objective.module').then(
        (m) => m.DevelopmentObjectiveModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: 'e2r',
    loadChildren: () =>
      import('./modules/e2r/e2r-public.module').then(
        (m) => m.E2rPublicModule
      ),
  },
  {
    path: 'e2r',
    loadChildren: () =>
      import('./modules/e2r/e2r.module').then(
        (m) => m.E2rModule
      )
  },
  {
    path: '',
    loadChildren: () => import('./modules/framework/framework.module').then((m) => m.FrameworkModule),
  },
  {
    path: 'lms',
    loadChildren: () =>
      import('./modules/lms/lms.module').then((m) => m.LmsModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: 'performance-objectives',
    loadChildren: () =>
      import('./modules/performance-objectives/objective.module').then(
        (m) => m.PerformanceObjectiveModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: '',
    loadChildren: () => import('./modules/personnel-files/personnel-files.module').then((m) => m.PersonnelFilesModule),
  },
  {
    path: 'projects',
    loadChildren: () =>
      import('./modules/projects/projects.module').then(
        (m) => m.ProjectsModule
      ),
    canActivate: [AuthenticationGuardService],
    data: {},
  },
  {
    path: '',
    loadChildren: () => import('./modules/publicrs/publicrs.module').then(x => x.PublicRsModule),
  },
  {
    path: 'qualifications',
    loadChildren: () =>
      import('./modules/qualifications/qualification.module').then(
        (m) => m.QualificationModule
      ),
    data: {
      fullPath: 'lms.qualifications',
    },
  },
  {
    path: 'reviews',
    loadChildren: () =>
      import('./modules/reviews/reviews.module').then(
        (m) => m.ReviewsModule
      ),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: 'rs',
    loadChildren: () =>
      import('./modules/rs/base/rs.module').then((m) => m.RsModule),
    canActivate: [AuthenticationGuardService],
  },

  {
    path: 'skills',
    loadChildren: () =>
      import('./modules/skills/skills.module').then((m) => m.SkillsModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: 'style-guide',
    component: StyleGuideComponent,
    canActivate: [AuthenticationGuardService],
    data: {
      showLayout: true
    },
  },
  {
    path: 'style-guide-settings',
    component: StyleGuideSettingsComponent,
    canActivate: [AuthenticationGuardService],
    data: {
      showLayout: true
    },
  },
  {
    path: 'thalento',
    loadChildren: () =>
      import('./modules/thalento/thalento.module').then((m) => m.ThalentoModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: 'timesheets',
    loadChildren: () =>
      import('./modules/timesheets/timesheets.module').then((m) => m.TimesheetsModule),
    canActivate: [AuthenticationGuardService],
  },
  {
    path: 'shared',
    loadChildren: () => import('./shared/shared-routing.module').then((m) => m.SharedRoutingModule),
    canActivate: [AuthenticationGuardService]
  },
  ...classicRoutes,
  ...managerRoutes,
  ...delegateRoutes,
  ...chrRoutes,
  {
    // 404 route not found
    path: '**', component: DefaultComponent
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
      onSameUrlNavigation: 'reload',
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
      // relativeLinkResolution: 'corrected',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
